import { createApi } from "@reduxjs/toolkit/query/react";
import { application } from "globals/endpoints";
import { telemetry } from "globals/endpoints";
import NotificationManager from "globals/websocket/WebSocket";

export const hospitalapi = createApi({
  reducerPath: "hospitalapi",
  baseQuery: async (args) => {
    try {
      if (typeof args == "string") {
        const result = await application(args);
        return result;
      } else {
        const { url, method, body } = args;
        const result = await application({ url, method, data: body });
        return result;
      }
    } catch (axiosError) {
      return { error: axiosError.response?.data || axiosError.message };
    }
  },
  tagTypes: ["extensionRefetch"],
  endpoints: (builder) => ({
    getHospitalJSON: builder.query({
      query: () => ({
        url: "configJson/getConfigFile",
        method: "GET",
      }),
      transformResponse: (res) => res.data.data,
      providesTags: ["extensionRefetch"],
    }),
    updateHopsitalJSON: builder.mutation({
      query: (payload) => ({
        url: "configJson/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["extensionRefetch"],
    }),
    addExtensionData: builder.mutation({
      query: (payload) => ({
        url: "extensions/dynamicCreate",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["extensionRefetch"],
    }),
    updateExtensionsCOS: builder.mutation({
      query: (payload) => ({
        url: "extensions/multipleUpdate/cos",
        method: "POST",
        body: payload,
      }),
    }),

    deleteNode: builder.mutation({
      query: (payload) => ({
        url: "extensions/delete/Extension",
        method: "POST",
        body: payload,
      }),
    }),
    deleteInboundCos: builder.mutation({
      query: (payload) => ({
        url: "inboundCos/delete",
        method: "POST",
        body: payload,
      }),
    }),

    deleteOutboundCos: builder.mutation({
      query: (payload) => ({
        url: "outboundCos/delete",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetHospitalJSONQuery,
  useUpdateHopsitalJSONMutation,
  useAddExtensionDataMutation,
  useUpdateExtensionsCOSMutation,
  useDeleteNodeMutation,
  useDeleteInboundCosMutation,
  useDeleteOutboundCosMutation,
} = hospitalapi;
